import _ from 'lodash'
import $ from 'jquery'
import Actor from './actor'
import globals from 'scoreboard/components/globals'
import FormActionType from 'scoreboard/forms/model/form-action-type'
const { SAVE_RECORD } = FormActionType
import FormHelper from 'scoreboard/components/form-helper'
const { readFromDom } = FormHelper
import FilterElements from 'scoreboard/components/filter-elements'
import {getDialogDatasetOrDataset} from '../edit/pages-edit'
const { filterElementAndChildren } = FilterElements

/**
 * Given a list of conditional statements and a dataset record, returns the form
 * actions that should be executed
 */
class EvaluateStatementsActor extends Actor {

	/**
	 * #53595 For users without modify records permission, we don't want to have
	 * enabled buttons, then disable them once we figure out that they result in
	 * a save action. This method leverages the evaluate-statements endpoint to
	 * perform an early check on the statements of multiple widgets to see if
	 * any of them result in a save
	 */
	check() {
		const { statements } = this.options
		const data = _.extend({}, { statements }, this.getRequestData())
		return $.post({
			url: 'api/forms/evaluate-statements',
			data: JSON.stringify(data)
		}).then(results => {
			const flags = new Array(_.size(statements)).fill(null);
			_.each(results, (widgetResults, wi) => {
				flags[wi] = false
				const widgetStatements = statements[wi]
				_.each(widgetResults, (groupIndex, gi) => {
					const groupStatements = widgetStatements[gi]
					const savePresent = _.some(groupStatements[groupIndex].consequences,
						c => c.type === SAVE_RECORD)
					if (!!savePresent) flags[wi] = true
				})
			})
			return flags
		})
	}

	/**
	 * this method evaluates a single widget/page's conditional statements and
	 * returns the corresponding actions
	 */
	act(sg) {
		// Prioritize using a passed in statement group; otherwise, use the
		// widget's statements followed by the form's statements
		let statementGroups = sg || this.options.widget?.statements
			|| this.model.get('statements')
		if (_.size(statementGroups) == 0) return Promise.resolve([])

		// if there are only else conditions (consequences) present, we can just
		// return the actions associated with them
		if (!_.some(statementGroups, s => _.size(s) > 1)) {
			return Promise.resolve(_.flatMap(statementGroups, s => s[0].consequences))
		}

		// wrap statements in an array as the endpoint expects that
		statementGroups = [ statementGroups ]

		const data = _.extend({}, { statements: statementGroups }, this.getRequestData())
		return $.post({
			url: 'api/forms/evaluate-statements',
			data: JSON.stringify(data)
		}).then(statementNums => {
			statementNums = statementNums[0]
			const actions = []
			_.each(statementGroups[0], (s, i) => {
				const consequences = s[statementNums[i]].consequences ?? []
				actions.push(...consequences)
			})
			return actions
		})
	}

	getRequestData() {
		const record = this.getData() || {}
		const dataset = getDialogDatasetOrDataset(this.model)
		const datasetId = dataset?.id || null
		const fieldValues = this._getRecordFields()
		const recordFieldIds = _.map(fieldValues, 'id')
		const calendarPeriodId = globals.periodId
		return { record, datasetId, recordFieldIds, calendarPeriodId }
	}

	readFromDom() {
		// #56104 statements are evaluated based on what's in the DOM, but we don't
		// want to read from record list widgets just like we don't for when we're saving
		// a record, because the record list widget has it's own internal logic for reading
		// from the DOM. With conditional actions, the user will be presented with a save
		// guard before evaluating any of the statements, so we don't need to worry about
		// reading from the DOM in that case
		const nonRecordListElements = filterElementAndChildren(
			this.formView, '.record-list-widget')
		return readFromDom(nonRecordListElements)
	}

}

export default EvaluateStatementsActor
EvaluateStatementsActor.__filename__ = 'forms/actions/evaluate-statements-actor.js'
